import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Effect } from "./Effect";
import { Filter } from "../component/filter/Filter";
import { Follower } from "../component/analysis/Follower";
import { optionsFromArguments } from "../core/util/Defaults";
import { Gain } from "../core/context/Gain";
import { dbToGain, gainToDb } from "../core/type/Conversions";
import { ScaleExp } from "../signal/ScaleExp";
import { readOnly } from "../core/util/Interface";
/**
 * AutoWah connects a [[Follower]] to a [[Filter]].
 * The frequency of the filter, follows the input amplitude curve.
 * Inspiration from [Tuna.js](https://github.com/Dinahmoe/tuna).
 *
 * @example
 * const autoWah = new Tone.AutoWah(50, 6, -30).toDestination();
 * // initialize the synth and connect to autowah
 * const synth = new Tone.Synth().connect(autoWah);
 * // Q value influences the effect of the wah - default is 2
 * autoWah.Q.value = 6;
 * // more audible on higher notes
 * synth.triggerAttackRelease("C4", "8n");
 * @category Effect
 */

export var AutoWah = /*#__PURE__*/function (_Effect) {
  _inherits(AutoWah, _Effect);

  var _super = _createSuper(AutoWah);

  function AutoWah() {
    var _this;

    _classCallCheck(this, AutoWah);

    _this = _super.call(this, optionsFromArguments(AutoWah.getDefaults(), arguments, ["baseFrequency", "octaves", "sensitivity"]));
    _this.name = "AutoWah";
    var options = optionsFromArguments(AutoWah.getDefaults(), arguments, ["baseFrequency", "octaves", "sensitivity"]);
    _this._follower = new Follower({
      context: _this.context,
      smoothing: options.follower
    });
    _this._sweepRange = new ScaleExp({
      context: _this.context,
      min: 0,
      max: 1,
      exponent: 0.5
    });
    _this._baseFrequency = _this.toFrequency(options.baseFrequency);
    _this._octaves = options.octaves;
    _this._inputBoost = new Gain({
      context: _this.context
    });
    _this._bandpass = new Filter({
      context: _this.context,
      rolloff: -48,
      frequency: 0,
      Q: options.Q
    });
    _this._peaking = new Filter({
      context: _this.context,
      type: "peaking"
    });
    _this._peaking.gain.value = options.gain;
    _this.gain = _this._peaking.gain;
    _this.Q = _this._bandpass.Q; // the control signal path

    _this.effectSend.chain(_this._inputBoost, _this._follower, _this._sweepRange);

    _this._sweepRange.connect(_this._bandpass.frequency);

    _this._sweepRange.connect(_this._peaking.frequency); // the filtered path


    _this.effectSend.chain(_this._bandpass, _this._peaking, _this.effectReturn); // set the initial value


    _this._setSweepRange();

    _this.sensitivity = options.sensitivity;
    readOnly(_assertThisInitialized(_this), ["gain", "Q"]);
    return _this;
  }

  _createClass(AutoWah, [{
    key: "octaves",
    get:
    /**
     * The number of octaves that the filter will sweep above the baseFrequency.
     */
    function get() {
      return this._octaves;
    },
    set: function set(octaves) {
      this._octaves = octaves;

      this._setSweepRange();
    }
    /**
     * The follower's smoothing time
     */

  }, {
    key: "follower",
    get: function get() {
      return this._follower.smoothing;
    },
    set: function set(follower) {
      this._follower.smoothing = follower;
    }
    /**
     * The base frequency from which the sweep will start from.
     */

  }, {
    key: "baseFrequency",
    get: function get() {
      return this._baseFrequency;
    },
    set: function set(baseFreq) {
      this._baseFrequency = this.toFrequency(baseFreq);

      this._setSweepRange();
    }
    /**
     * The sensitivity to control how responsive to the input signal the filter is.
     */

  }, {
    key: "sensitivity",
    get: function get() {
      return gainToDb(1 / this._inputBoost.gain.value);
    },
    set: function set(sensitivity) {
      this._inputBoost.gain.value = 1 / dbToGain(sensitivity);
    }
    /**
     * sets the sweep range of the scaler
     */

  }, {
    key: "_setSweepRange",
    value: function _setSweepRange() {
      this._sweepRange.min = this._baseFrequency;
      this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(AutoWah.prototype), "dispose", this).call(this);

      this._follower.dispose();

      this._sweepRange.dispose();

      this._bandpass.dispose();

      this._peaking.dispose();

      this._inputBoost.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Effect.getDefaults(), {
        baseFrequency: 100,
        octaves: 6,
        sensitivity: 0,
        Q: 2,
        gain: 2,
        follower: 0.2
      });
    }
  }]);

  return AutoWah;
}(Effect);